import { orpc } from "@/utils/orpc.client";
import { QUERY_STALE_TIMES } from "@/utils/query-policies";

/** Read indexed catalog packing only for the editions displayed in the offer card. */
export function getReleaseAlternativePackingQueryOptions(input: {
  workId: string;
  releaseIds: string[];
}) {
  return orpc.music.searchWorkReleases.queryOptions({
    input: {
      id: input.workId,
      releaseIds: [...input.releaseIds].sort(),
      limit: Math.max(1, input.releaseIds.length),
    },
    staleTime: QUERY_STALE_TIMES.default,
  });
}
